import React from "react";
import TitleComponent from "../../components/title/Title";
import StockTable from "./StockTable";

function StockMain() {
  return (
    <div className="body--container">
      <TitleComponent title="Stock" />
      <StockTable />
    </div>
  );
}

export default StockMain;
